<div class="sheet-header">
  <ng-container>{{pricingName}}</ng-container>

  <div class="space-block">

  </div>

  <button mat-button (click)="addNewLine()" class="new-item-button" *ngIf="listIsEditable">
    <ng-container *ngIf="typeOfSheet !== 'Notes'">New Item</ng-container>
    <ng-container *ngIf="typeOfSheet === 'Notes'">New Line</ng-container>
  </button>
</div>
<div #table class="sheet-table">

</div>


<div class="loading-block" *ngIf="!listIsEditable && customTableLoading">
  <lib-progress-spinner></lib-progress-spinner>
</div>
